define("shared/utils/constants/social-profile", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.InstagramAccountTypes = _exports.AccountTypes = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  let AccountTypes = _exports.AccountTypes = /*#__PURE__*/function (AccountTypes) {
    AccountTypes["Instagram"] = "Instagram";
    AccountTypes["Twitter"] = "Twitter";
    AccountTypes["Facebook"] = "Facebook";
    AccountTypes["TikTok"] = "TikTok";
    AccountTypes["LinkedIn"] = "LinkedIn";
    AccountTypes["Pinterest"] = "Pinterest";
    return AccountTypes;
  }({});
  let InstagramAccountTypes = _exports.InstagramAccountTypes = /*#__PURE__*/function (InstagramAccountTypes) {
    InstagramAccountTypes["Personal"] = "personal";
    InstagramAccountTypes["Creator"] = "creator";
    InstagramAccountTypes["Business"] = "business";
    return InstagramAccountTypes;
  }({});
});